import { render, staticRenderFns } from "./CardLayoutChoose.vue?vue&type=template&id=58065c84&scoped=true&"
import script from "./CardLayoutChoose.vue?vue&type=script&lang=js&"
export * from "./CardLayoutChoose.vue?vue&type=script&lang=js&"
import style0 from "./CardLayoutChoose.vue?vue&type=style&index=0&id=58065c84&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58065c84",
  null
  
)

export default component.exports